import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { ScatterChart, Scatter, XAxis, YAxis, ZAxis, Tooltip } from 'recharts'
import R from 'ramda'
import moment from 'moment'
import styled from 'styled-components'
import TeacherDistributionActions from '../../Data/Redux/TeacherDistributionRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import ReportTemplate from './ReportTemplate'
import BubbleTooltip from '../../Components/ReportsComponents/BubbleTooltip'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

const Container = styled.div`
  padding: 20px;
  box-sizing: border-box;
`

class TeacherDistribution extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [{ id: '00', hour: '12 AM', total: 0 }, { id: '01', hour: '01 AM', total: 0 }, { id: '02', hour: '02 AM', total: 0 }, { id: '03', hour: '03 AM', total: 0 },
        { id: '04', hour: '04 AM', total: 0 }, { id: '05', hour: '05 AM', total: 0 }, { id: '06', hour: '06 AM', total: 0 }, { id: '07', hour: '07 AM', total: 0 },
        { id: '08', hour: '08 AM', total: 0 }, { id: '09', hour: '09 AM', total: 0 }, { id: '10', hour: '10 AM', total: 0 }, { id: '11', hour: '11 AM', total: 0 },
        { id: '12', hour: '12 PM', total: 0 }, { id: '13', hour: '01 PM', total: 0 }, { id: '14', hour: '02 PM', total: 0 }, { id: '15', hour: '03 PM', total: 0 },
        { id: '16', hour: '04 PM', total: 0 }, { id: '17', hour: '05 PM', total: 0 }, { id: '18', hour: '06 PM', total: 0 }, { id: '19', hour: '07 PM', total: 0 },
        { id: '20', hour: '08 PM', total: 0 }, { id: '21', hour: '09 PM', total: 0 }, { id: '22', hour: '10 PM', total: 0 }, { id: '23', hour: '11 PM', total: 0 }],
      checkOut: [],
      showDetail: false,
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getTeacherDistribution, getClassrooms } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'attendance/teacher-distribution')
        getClassrooms({'basic':true,'students':false})
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'attendance/teacher-distribution')
        getClassrooms({'basic':true,'students':false})
      }
    } else {
      getTeacherDistribution()
    }
    if (this.props.user === 'Director') {
      this.props.getClassrooms({'basic':true,'students':false})
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const { teacherDistribution, user, centers, classrooms, centersInfo, fromCenter, activeCenter } = nextProps
    const newData = []
    if (user === 'Director') {
      if (!R.isEmpty(teacherDistribution)) {
        const keys = Object.keys(teacherDistribution)
        keys.sort()
        for (let i = 0; i < classrooms.length; i++) {
          const classroom = []
          if (classrooms[i].name === 'Sala de Síntomas') {
            classroom.name = 'Sintomas'
          } else {
            classroom.name = classrooms[i].name
          }
          classroom.id = classrooms[i].id
          newData.push(classroom)
          const totals = []
          keys.map((key) => {
            const format = `${key}00`
            const hour = { hour: moment(format, 'hmm').format('hh A'), index: 1 }
            const selected = teacherDistribution[key].find(c => c.classroom_id === classrooms[i].id)
            hour.value = selected.teachers_required
            hour.id = selected.classroom_id
            totals.push(hour)
          })
          const activeIndex = R.findIndex(R.propEq('id', classrooms[i].id))(newData)
          newData[activeIndex].push(totals)
        }
        this.setState({ data: newData })
      }
    } if (user === 'Back Office Admin') {
      if (fromCenter) {
        if (centersInfo && !R.isEmpty(centersInfo)) {
          let centerToShow = null
          let classroomsToRender = null
          if (classrooms && centers) {
            centerToShow = centers.find(c => c.id == activeCenter);
            classroomsToRender = classrooms.filter(cl => cl.center == centerToShow.name)
          }
          if (classroomsToRender) {
            const keys = Object.keys(centersInfo)
            keys.sort()
            for (let i = 0; i < classroomsToRender.length; i++) {
              const classroom = []
              if (classroomsToRender[i].name === 'Sala de Síntomas') {
                classroom.name = 'Sintomas'
              } else {
                classroom.name = classroomsToRender[i].name
              }
              classroom.id = classroomsToRender[i].id
              newData.push(classroom)
              const totals = []
              keys.map((key) => {
                const format = `${key}00`
                const hour = { hour: moment(format, 'hmm').format('hh A'), index: 1 }
                const selected = centersInfo[key].find(c => c.classroom_id === classroomsToRender[i].id)
                hour.value = selected.teachers_required
                hour.id = selected.classroom_id
                totals.push(hour)
              })
              const activeIndex = R.findIndex(R.propEq('id', classroomsToRender[i].id))(newData)
              newData[activeIndex].push(totals)
            }
          }
          this.setState({ data: newData })
        }
      }
      if (!R.isEmpty(teacherDistribution)) {
        const keys = Object.keys(teacherDistribution)
        keys.sort()
        for (let i = 0; i < centers.length; i++) {
          const center = []
          center.name = centers[i].abbreviation
          center.id = centers[i].id
          newData.push(center)
          const totals = []
          keys.map((key) => {
            const format = `${key}00`
            const hour = { hour: moment(format, 'hmm').format('hh A'), index: 1 }
            const selected = teacherDistribution[key].find(c => c.center_id === centers[i].id)
            hour.value = selected.teachers_required
            hour.id = selected.center_id
            totals.push(hour)
          })
          const activeIndex = R.findIndex(R.propEq('id', centers[i].id))(newData)
          newData[activeIndex].push(totals)
        }
        this.setState({ data: newData })
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  getChart = () => {
    const { width, data, showDetail } = this.state
    const dataToShow = []
    let domain = [0, 0]
    const range = [28, 100]
    const number = showDetail ? data.length : 5
    for (let i = 0; i < number; i++) {
      dataToShow.push(data[i])
    }
    if (dataToShow.length > 0) {
      const charts = dataToShow.map((currentValue, index) => {
        if (currentValue && currentValue[0]) {
          domain = this.parseDomain(currentValue[0])
        }
        return (
          <ScatterChart
            key={index}
            width={width < 763 ? 400 : 608}
            height={55}
            margin={{ top: 10, right: 20, left: 20, bottom: 0 }}
          >
            <XAxis type="category" dataKey="hour" interval={2} padding={{ left: 30 }} tick={width < 763 ? { fontSize: index === (dataToShow.length - 1) ? 8 : 0 } : { fontSize: index === (dataToShow.length - 1) ? 12 : 0 }} tickLine={false} />
            <YAxis type="number" dataKey="index" name={currentValue && currentValue.name} height={5} width={50} tick={false} tickLine={false} axisLine={false} label={{ value: currentValue && currentValue.name, position: 'insideLeft', fontSize: '12' }} />
            <ZAxis type="number" dataKey="value" domain={domain} range={range} />
            <Tooltip wrapperStyle={{ zIndex: 100 }} content={<BubbleTooltip />} />
            <Scatter data={currentValue && currentValue[0]} fill="#4A90E2" />
          </ScatterChart>
        )
      })
      return charts
    }
    return null
  }

  clickDetail = () => {
    this.setState({ showDetail: !this.state.showDetail })
  }

  parseDomain = (data) => {
    return [
      0,
      Math.max.apply(null, [
        ...data.map(entry => entry.value)
      ])
    ]
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('attendance/teacher-distribution', this.props.activeCenter)
    } else {
      this.props.getTeacherDistributionExcel()
    }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  render() {
    const { teacherDistribution, user, centers, fromCenter, centersInfo } = this.props
    const { width, data, checkOut, showDetail } = this.state
    return (
      <ReportTemplate
        title="Formadoras Necesarias / hora"
        onClick={this.download}
        detail
        detailText={showDetail ? 'Ocultar Detalle' : 'Ver Detalle'}
        onClickDetail={this.clickDetail}
        date={{ initial: moment().subtract(1, 'months').format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD') }}
        loading={((R.isEmpty(TeacherDistribution) && R.isEmpty(centersInfo)))}
      >
        {(!(R.isEmpty(teacherDistribution)) || !(R.isEmpty(centersInfo))) &&
          <Container>
            {this.getChart()}
          </Container>
        }
      </ReportTemplate>
    )
  }
}


const mapStateToProps = ({ teacherDistribution, centerOptions, auth, classrooms, centersInfo }) => ({
  teacherDistribution: teacherDistribution.get.results,
  centers: centerOptions.get.results,
  user: auth.user.role,
  classrooms: classrooms.get.results,
  centersInfo: centersInfo.teacher_distribution.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getTeacherDistribution: () => dispatch(TeacherDistributionActions.getRequest({}, true)),
  getTeacherDistributionExcel: () => dispatch(TeacherDistributionActions.TeacherDistributionExcelRequest({}, true)),
  getClassrooms: (query) => dispatch(ClassroomActions.getRequest(query)),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TeacherDistribution))



// WEBPACK FOOTER //
// ./src/Containers/Reports/TeacherDistribution.jsx